/*
 * DashboardMfa Messages
 *
 * This contains all the text for the DashboardMfa component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.DashboardMfa";

export default defineMessages(scope, {
  header: "Update MFA",
  pText: "Enter Password",
  save: "Save",
  next: "Next",
  cancelButtonLabel: "Cancel",
  done: "Done",
  removeMFA: "Are you sure you want to remove this option?",
  passwordError: "Please try again.", // NOSONAR
  configured: "Cannot be removed for 24 hours after this method is configured.",
  noAuthenticatorsError:
    "At least one multi-factor authentication option must be configured",
});
